
import { Component, Input } from '@angular/core';
import { JumpToOperator } from './api/jump-to-operator.api';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: 'app-jump-to[pageType][selectedCode]',
    // inputs: ['selectedCode', 'pageType'],
    templateUrl: './jump-to.component.html',
    standalone: false
})
export class JumpToComponent{

	@Input()
	public operator: JumpToOperator;

	@Input()
	public minified: boolean = true;

	//#region <Page type.>
	private _pageType: 'eso' | 'fc';
	public get pageType(): 'eso' | 'fc' {
		return this._pageType;
	}
	@Input()
	public set pageType(value: 'eso' | 'fc') {
		this._pageType = value;

		if (!this.operator) {
			this.operator = new JumpToOperator();
		}

		this.operator.pageType = this._pageType;
	}
	//#endregion

	//#region <Selected code.>
	private _selectedCode: string;
	public get selectedCode(): string {
		return UtilsService.getURLHelper(this._selectedCode);
	}
	@Input()
	public set selectedCode(value: string) {
		this._selectedCode = UtilsService.getURLHelper(value);

		if (!this.operator) {
			this.operator = new JumpToOperator();
		}

		this.operator.selectedCode = this._selectedCode;
	}
	//#endregion


	
	@Input() needConfirmation: boolean = false;
	@Input() confirmJump!: () => boolean;

	public onItemChange($event: any) {

	if (this.needConfirmation) {
		const isConfirmed = this.confirmJump();
		if (isConfirmed) {
			this.operator.onSchemaItemClicked($event);
		}
		} else {
			this.operator.onSchemaItemClicked($event);
		}
	}

	constructor() { }
}
